export enum ReasonCancelTypesEnum {
  CANCELLATION = "CANCELLATION",
  FLEET_ADMIN_REPROVE = "FLEET_ADMIN_REPROVE",
  DONT_CONFIRM_CONCLUSION = "DONT_CONFIRM_CONCLUSION"
}
